export const EMPTY_COMPONENT = {
    displayName: "",
    description: "",
    input: [],
    output: [],
    status: "",
    configurationSections: [],
    configurations: []
};
